export const NONE = 'NO_ACCESS';
const NONE_LEVEL = 1;

export const USER = 'USER';
const USER_LEVEL = 2;

export const ADMIN = 'ADMIN';
const ADMIN_LEVEL = 3;

const defaultRoleKey = 'default_partner_role';

const roleToLevel = {
    [NONE]: NONE_LEVEL,
    [USER]: USER_LEVEL,
    [ADMIN]: ADMIN_LEVEL,
};

/**
 * Extract the role for the current application out of the user. This is useful
 * when one needs to display the application role.
 *
 * @param object user The current user (from `useCurrentUser`)
 * @return string the application role
 */
export function roleFor(
    partnerId,
    { partnerMap, [defaultRoleKey]: defaultRole },
) {
    return partnerMap[partnerId]?.role || defaultRole;
}

/**
 * Check to see if the user is granted the the given role for the partner.
 *
 *      import { partnerRoles } from '@alli/frontend-common';
 *
 *      // in a component somewhere
 *      const currentUser = useCurrentUser();
 *      if (appRoles.isGranted(process.env.APPLICATION_ID, appRoles.ADMIN, currentUser)) {
 *          // ...
 *      }
 *
 * @param string partnerId a partner id
 * @param string wantedRole one of the role constants above
 * @param object user The current user (from `useCurrentUser`)
 * @return bool True if the user is at or above the role level
 */
export function isGranted(partnerId, wantedRole, user) {
    const wantedLevel = roleToLevel[wantedRole];
    if (!wantedLevel) {
        return false; // invalid wanted role
    }

    const currentRole = roleFor(partnerId, user);
    const currentLevel = roleToLevel[currentRole] || -1;

    return currentLevel >= wantedLevel;
}
